import React, { Component } from 'react';
import PropTypes from 'prop-types';
import UserRoomsListContainer from 'components/Messenger/containers/UserRoomsListContainer';
import qs from 'qs';
import _ from 'lodash';
import { t } from 'utils/translates';

import MediumPreLoader from 'components/Common/PreLoaders/MediumPreLoader';
import SearchInput from 'components/Common/Inputs/SearchInput';

import UserRoomsList from './UserRoomsList';
import UserRoomsSearchBlock from './UserRoomsSearchBlock';
import PaginationBlock from '../../../Common/Pagination/PaginationBlock';

class UserRoomsListIndex extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchInput: this.getSearchParamFromUrl(props) || ''
    };
  }

  componentDidUpdate(prevProps) {
    if (
      this.getSearchParamFromUrl(prevProps) !==
      this.getSearchParamFromUrl(this.props)
    ) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ searchInput: this.getSearchParamFromUrl(this.props) });
    }
  }

  getSearchParamFromUrl = props =>
    _.get(qs.parse(props.location.search.slice(1)), 'msgs.search');

  render() {
    if (this.props.requestState.inProgress) {
      return <MediumPreLoader />;
    }
    if (this.props.itemsIds.length === 0) {
      return (
        <div className="alert alert-default text-center">
          <p>
            {t(
              'У вас еще нет диалогов. Создайте группу или напишите личное сообщение пользователю со страницы его профиля.'
            )}
          </p>
        </div>
      );
    }
    return (
      <div>
        <div className="panel panel-default panel-heading_padding-large">
          <div className="panel-heading">
            <div className="media full-width">
              <div className="media-body media-middle full-width">
                <h1 className="panel-title">
                  <i className="fa fa-comments-o fa-lg" /> {t('Сообщения')}
                </h1>
              </div>
              <div className="media-right media-middle text-overflow">
                <a
                  href=""
                  className="btn btn-default visible-sm-inline-block"
                  data-toggle="sidebar-r"
                >
                  {t('Фильтр')}&nbsp;
                  <i className="fa fa-lg fa-filter text-muted" />
                </a>
              </div>
            </div>
          </div>
          <div className="panel-body bg-sub border-simple-b">
            <div className="input-group">
              <span className="input-group-addon">
                <i className="fa fa-search" />
              </span>
              <SearchInput
                type="search"
                className="form-control"
                id="employerSearch"
                placeholder={t('Поиск')}
                onChange={e => {
                  this.setState({ searchInput: e.target.value });
                }}
                value={this.state.searchInput}
              />
            </div>
          </div>
          {this.state.searchInput === '' ? (
            <UserRoomsList
              itemsIds={this.props.itemsIds}
              auntUserId={this.props.auntUserId}
              selectItemById={this.props.selectItemById}
            />
          ) : (
            <UserRoomsSearchBlock searchInput={this.state.searchInput} />
          )}
        </div>
        <PaginationBlock
          paginationData={this.props.pagination}
          handlePageClick={pageNumber => {
            window.scroll({ top: 0, left: 0, behavior: 'smooth' });
            this.props.changeQueryParams({ page: pageNumber });
            this.props.sendRequest();
          }}
        />
      </div>
    );
  }
}

UserRoomsListIndex.propTypes = {
  auntUserId: PropTypes.number.isRequired,
  requestState: PropTypes.shape({
    inProgress: PropTypes.bool.isRequired,
    countQueries: PropTypes.number.isRequired
  }).isRequired,
  itemsIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  selectItemById: PropTypes.func.isRequired,
  changeQueryParams: PropTypes.func.isRequired,
  sendRequest: PropTypes.func.isRequired,
  pagination: PropTypes.shape({
    currentPage: PropTypes.number.isRequired,
    pageCount: PropTypes.number.isRequired,
    perPage: PropTypes.number.isRequired,
    totalCount: PropTypes.number.isRequired
  }).isRequired
};

export default UserRoomsListContainer(UserRoomsListIndex);



// WEBPACK FOOTER //
// ./src/components/Messenger/content/UserRoomsList/index.js